module.exports = __webpack_public_path__ + "img/grid-row-details.26bf4eea.png";